module.exports = require("scroll-to-element");


//////////////////
// WEBPACK FOOTER
// external "scroll-to-element"
// module id = 534
// module chunks = 0